import { BROWSER_TEST } from "../actions/types";

const initialState = {
  error: null,
  isLoading: false,
  lang: null,
  test_lang: null,
  logId: null,
  userId: null,
  screenerDraftId: null,
  exitText: null,
  isScreener: null,
  screenerSetId: null,
  screenerResponseId: null,
  testDetails: {},
  testDataFetched: false,
  countries: [],
  susStartTime: null,
  susEndTime: null,
  susAnswers: [],
  progress: null,
  taskResponses: [],
  previewError: false,
  screenerFailed: false,
  activeTaskIndex: 0,
};

const browserTestReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case BROWSER_TEST.UPDATE:
      return { ...state, isLoading: false, error: null, ...payload };

    case BROWSER_TEST.RESET:
      return initialState;

    case BROWSER_TEST.ERROR:
      return { ...state, isLoading: false, error: payload };

    default:
      return state;
  }
};

export default browserTestReducer;
